export default "__VITE_ASSET__B12taR4W__"